import { PlayerKebabMenu } from '@library/components/menus';
import { ShowProjectionsModalButton } from '@library/components/buttons';
import type { Status } from '@library/types/projection';

export interface TradingProjectionControlsProps {
  gameId: string;
  handleShowAutoTradeDrawer: () => void;
  playerBulkActions: {
    handleChangeStatus: (status: Status) => Promise<void>;
    handleChangeInGame: (inGame: boolean) => Promise<void>;
  };
  playerModalActions: {
    handleShowPlayerModal: () => void;
    handleShowGameModes: () => void;
  };
  isBulkPlayerInGameEnabled: boolean;
}

export const TradingProjectionControls = ({
  gameId,
  handleShowAutoTradeDrawer,
  isBulkPlayerInGameEnabled,
  playerBulkActions,
  playerModalActions
}: TradingProjectionControlsProps) => {
  return (
    <div className="flex w-20 flex-row items-center gap-4 pr-4">
      <ShowProjectionsModalButton
        onClick={playerModalActions.handleShowPlayerModal}
      />
      <PlayerKebabMenu
        disabled={gameId.includes('NLS')}
        handleShowAutoTradeDrawer={handleShowAutoTradeDrawer}
        isBulkPlayerInGameEnabled={isBulkPlayerInGameEnabled}
        playerBulkActions={playerBulkActions}
        playerModalActions={playerModalActions}
      />
    </div>
  );
};
